import vue from 'vue';
import { default as Component } from 'vue-class-component';

import IocContainer from '../../../container/IocContainer';
import SERVICES from '../../../services/services';

import User from '../../../interfaces/User';
import Auth from '../../../interfaces/Auth';

@Component({
  template: require('./new-password-page.html'),
  props: {
    token: String,
  },
})
export class NewPasswordPage extends vue {
  token;
  password = '';
  passwordConformation = '';
  error = '';

  email = '';

  auth = IocContainer.get < Auth > (SERVICES.AUTH);

  mounted() {
    if (this.auth.isAuthenticated()) {
      this.$router.push({ name: 'course' });
    }
    this.auth.resetTokenValidate(this.token).then(
      (response) => {
        console.log(response);
        this.email = response.data.email;
      },
      (error) => {
        console.log(error);
        this.errorReport(error);
      },
    );
  }

  resetPassword() {
    this.error ='';
    this.auth.resetPasswordConformation(this.email, this.token, this.password, this.passwordConformation).then(
      (response) => {
        console.log(response);
        this.error = 'Password has been changed';
      },
      (error) => {
        this.errorReport(error);
      },
    );
  }

  errorReport(error) {
    this.error = error.response.data.message;
  }
}